<template>
    <div class="pcdetails">
        <el-backtop target=".pcdetails"></el-backtop>
        <div class="pchome-headerque">
            <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
        </div>
        <div class="productc" :class="productc_nav?'productc_nav':''">
            <div class="productc-left">
                {{uservices}}
            </div>
            <div class="productc-right">
                <div class="right-detail" :style="acindex==1?'color:'+nav_color:''" @click="aciscoll(1)">
                    {{anticoniden}}
                </div>
                <div class="right-instructions" :style="acindex==2?'color:'+nav_color:''" @click="aciscoll(2)">
                    {{maintenance}}
                </div>
                <div class="right-parameter" :style="acindex==3?'color:'+nav_color:''" @click="aciscoll(3)">
                    {{dadownlo}}
                </div>
                <div class="right-maintain" :style="acindex==4?'color:'+nav_color:''" @click="aciscoll(4)">
                    {{comprob}}
                </div>
            </div>
        </div>
        <div style="padding:10px 0;opacity:0" v-if="productc_nav">
            <div class="productc-left">
                {{uservices}}
            </div>
        </div>
        <div class="linesd"></div>
        <div class="pcho-querysf" id="pchoquersf">
            <div class="pcho-queryheasf" ref="haanticoniden">{{haanticoniden}}</div>
            <div class="pcho-querycentsf">{{toptitle}}</div>
            <div class="pcho-queryinputsf">
                <input v-model="pcquersu" :placeholder="tips"/>
                <div class="inpt-but" @click="oponzmnqu()" :style="'background:'+nav_color">{{querysub}}</div>
            </div>
            <div class="pcho-query-titlesf">
                {{foptitle}}
            </div>
        </div>
        <div class="pcmaintenance" id="pcmainten">
            <div class="pcmanitenance-hea" ref="maintenance">
                {{maintenance}}
            </div>
            <div class="maintenance-cen">
                <div class="parcen-item" :style="maintenancetyps==item.id?'color:'+nav_color:''"
                     v-for="(item,index) in categorylist" @click="maintenancetypsclick(item.id)" :key="index">
                    {{item.name}}
                </div>
                <div class="hoverxia_icon" @click="maintenance_cen_icon_click()"
                     :style="maintenance_cen_bool?'transform:scale(1,-1)':'transform:scale(1,1)'"></div>
            </div>
            <div class="pcmaintenance-cont">
                <div class="pcmaintenance-item" v-for="(item,index) in downloadlistst_tpm" :key="index"
                     @click="downvideo(item.file)">
                    <div class="shop-video">
                        <video :src="item.file" :id="'video'+item.id" @mouseleave="video_out(item)" muted
                               v-if="playing_video_id == item.id"></video>
                        <img :src="item.image" v-else class="video_title_image" @mouseenter="video_in(item)">
                    </div>
                    <div class="shop-icon" @click="">
                        <div class="shopicon-left">
                            {{item.title}}
                        </div>
                        <div class="shopicon-right">
                            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcvideosimg/download.svg"/>
                        </div>
                    </div>
                </div>
            </div>
            <!-- v-if="item.list.length>item.mess2" -->
            <div class="querymainmore">
                <div class="quemore-but" @click="quenetmore()">
                    {{quenetworkco}}
                    <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg"
                         :style="weihtfa?'':'transform:scale(1,-1)'"/>
                </div>
            </div>
        </div>
        <div class="parameter" id="paradme">
            <div class="parameter-hea" ref="dadownlo">
                {{dadownlo}}
            </div>
            <div class="parameter-cen">
                <div class="parcen-item" :style="downloadtyps==item.id?'color:'+nav_color:''"
                     v-for="(item,index) in downloadtypst" @click="downloadtypsclick(item.id)" :key="index">
                    {{item.name}}
                </div>
                <div class="hoverxia_icon" @click="parameter_cen_icon_click()"
                     :style="parameter_cen_bool?'transform:scale(1,-1)':'transform:scale(1,1)'"></div>
            </div>
            <div class="parameter-foo">
                <div class="list-container">
                    <div class="parfoo-item" v-for="(item,index) in downloadlistst" :key="index">
                        <div class="parfooit-left">
                            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcqueryimg/pdf.svg"/>
                            {{item.title}}
                        </div>
                        <div class="parfooit-right">
                            <div @click="navtoshiyan(item.file)" v-if="!item.is_password">{{onlinepreview}}</div>
                            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcqueryimg/querydownload.svg"
                                 @click="dolofle(item)"/>
                        </div>
                    </div>
                </div>
                <!--				<div class="pagination" :class="topicClass" v-if="totalPage > 1">-->
                <!--					<el-pagination-->
                <!--							background-->
                <!--							@current-change="changePage"-->
                <!--							layout="prev, pager, next"-->
                <!--							:page-size="pageSize"-->
                <!--							:total="total">-->
                <!--					</el-pagination>-->
                <!--				</div>-->
            </div>
        </div>
        <div class="instructions" id="inscte">
            <div class="instructions-hea" ref='comprob'>
                {{comprob}}
            </div>
            <div class="instructions-cen">
                <div class="hoverxia_icon" @click="instructions_cen_icon_click()"
                     :style="instructions_cen_bool?'transform:scale(1,-1)':'transform:scale(1,1)'"></div>
                <div class="inscen-item" :style="problemtypestssy==item.id?'color:'+nav_color:''"
                     v-for="(item,index) in problemtypest" @click="problemtypestssyclick(item.id)" :key="index">
                    {{item.name}}{{item.id}}
                </div>
            </div>
            <div class="instructions-foo">
                <el-collapse accordion>
                    <el-collapse-item v-for="(item,index) in problemlistst" :key="index">
                        <template slot="title">
                            {{item.title}}
                        </template>
                        <div>{{item.content}}</div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
		<pop-up ref="popUp"></pop-up>
        <footers ref=is_change></footers>
    </div>
</template>

<script>
    import '@/lib-flexible/flexible.js'
    import {session} from '../../storage/storage.js';
    import headers from '../../common/header.vue'
    import footers from '../../common/footers.vue'
	import popUp from '../../common/pop-up.vue'


	export default {
        data() {
            return {
                maintenancetyps: 1,
                parameter_cen_bool: false,
                maintenance_cen_bool: false,
                instructions_cen_bool: false,
                playing_video_id: 0,
                productc_nav: false,
                id: '',
                pcquersu: '',
                quenetworkco: '显示更多',
                uservices: '用户服务',
                anticoniden: '防伪鉴别',
                dadownlo: '资料下载',
                maintenance: '维护保养',
                haanticoniden: '防伪查询',
                comprob: '常见问题',
                toptitle: '为了方便广大用户查询,我司于近期升级了防伪查询系统',
                foptitle: '温馨提示：您可以在啄木鸟产品外包装的防伪标签上找到防伪码',
                onlinepreview: '在线预览',
                tips: "请输入防伪码",
                querysub: '提交',
                navheader: true,
                heshow: false,
                show: false,
                playli: true,
                playri: true,
                acindex: 1,
                downloadtyps: 1,
                type_id: 2,
                typesss_id: 2,
                problemtypestssy: 2,
                downloadtypst: '',
                downloadlistst: '',
                downloadlistst_tpm: [],
                problemtypest: '',
                problemlistst: '',
                value: '',
                valuelang: '',
                wehnums: 8,
                weihtfa: true,
                categorylist: [],
                list_img: [
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic.png"),id:1,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic2.png"),id:2,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic3.png"),id:3,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic4.png"),id:4,is_cover:false},
                    //       { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic5.png"),id:5,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic.png"),id:6,is_cover:true},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic2.png"),id:2,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic3.png"),id:3,is_cover:false},
                    // { url: require("https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/pic4.png"),id:4,is_cover:false},
                ],
                nav_color: session.get('channel_id') == 1 ? '#e62129' : session.get('channel_id') == 2 ? '#1a4698' : '#5f5d5d',
                total: 0,
                page: 1,
                pageSize: 5,
                totalPage: 0,
                topicClass: ''
            }
        },
        components: {
            headers,
            footers,
			popUp
        },
        created() {
            this.getParams()
            this.pcdownloadtype()
            this.pcproblemtype()
            // this.pcproblemlist()s
            // this.pcdownloadtpmlist();
            this.heshow = true
            this.getProductList()
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                console.log('手机手机21321321')

                this.$router.push({path: './phquerys', query: {e: this.$route.query.e}})
            }
            sessionStorage.setItem('page', JSON.stringify({name: 'pcquerys', data: {e: this.$route.query.e}}))
            let id = session.get("channel_id");
            if (id == 1) {
                this.topicClass = 'wood'
            } else if (id == 2) {
                this.topicClass = 'dte'
            } else {
                this.topicClass = 'dba'
            }
        },
        watch: {
            '$route': 'getParams'
        },
        mounted() {
            document.addEventListener('scroll', this.handleScroll, false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll, false)
            })
            // setTimeout(() => {
            this.getParams()
            // }, 1000);
        },
        methods: {
            changePage(e) {
                this.page = e
                this.pcdownloadlist()
            },
            downvideo(e) {
                window.open(e)
            },
            parameter_cen_icon_click() {
                this.parameter_cen_bool = !this.parameter_cen_bool
                if (this.parameter_cen_bool) {
                    document.getElementsByClassName('parameter-cen')[0].style.height = 'auto'
                } else {
                    document.getElementsByClassName('parameter-cen')[0].style.height = '29px'
                }
            },
            maintenance_cen_icon_click() {
                this.maintenance_cen_bool = !this.maintenance_cen_bool
                if (this.maintenance_cen_bool) {
                    document.getElementsByClassName('maintenance-cen')[0].style.height = 'auto'
                } else {
                    document.getElementsByClassName('maintenance-cen')[0].style.height = '29px'
                }
            },
            instructions_cen_icon_click() {
                this.instructions_cen_bool = !this.instructions_cen_bool
                if (this.instructions_cen_bool) {
                    document.getElementsByClassName('instructions-cen')[0].style.height = 'auto'
                } else {
                    document.getElementsByClassName('instructions-cen')[0].style.height = '29px'
                }
            },
            scrolling() {
                // 滚动条距文档顶部的距离
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                    document.body.scrollTop
                // 滚动条滚动的距离
                let scrollStep = scrollTop - this.oldScrollTop;
                // 更新——滚动前，滚动条距文档顶部的距离
                this.oldScrollTop = scrollTop;
                // console.log(scrollTop)
                if (scrollStep < 0) {
                    this.navheader = false
                } else {
                    this.navheader = true
                }
            },
            video_in(item) {
                this.playing_video_id = item.id
                setTimeout(() => {
                    document.getElementById('video' + item.id).play()
                }, 10);
            },
            video_out(item) {
                document.getElementById('video' + item.id).pause()
                document.getElementById('video' + item.id).currentTime = 0
                setTimeout(() => {
                    this.playing_video_id = 0
                }, 10);
            },
            dolofle(e) {
                if (e.is_password) {
                    this.$refs.popUp.open(e)
                    return
                }
                var name = e.title;
                var url = e.file;
                var suffix = url.substring(url.lastIndexOf("."), url.length);
                //跳过浏览直接下载
                fetch(url)
                    .then(res => res.blob())
                    .then(blob => {
                        const a = document.createElement("a");
                        const objectUrl = window.URL.createObjectURL(blob);
                        a.download = name;
                        a.href = objectUrl;
                        a.click();
                        window.revokeObjectURL(objectUrl);
                    })
            },
            quenetmore() {
                if (this.weihtfa) {
                    this.wehnums += 8
                } else {
                    this.wehnums = 8

                }
                /* let e=this.weihcons */
                this.pcdownloadtpmlist()

            },
            ChangeEmit() { //子组件传递
                //主动调用子组件
                this.$refs.is_change.get_index_channel_data();
                this.$refs.is_change.pageParam();
                this.getParams()
                this.pcdownloadtype()
                this.pcproblemtype()
                this.getProductList()
                // this.pcproblemlist()
                this.pageParam() //页面静态参数
                // this.pcdownloadtpmlist();
            },
            oponzmnqu() {
                /* let af=23682052 */
                let af = this.pcquersu
                /* window.location.href = 'URL'; */
                window.location.href = "http://cx.glwoodpecker.com.cn:88/Wp/gl?af=" + af;
            },
            navtoshiyan(e) {
                window.open(e)
            },
            pcdownloadtype() {
                let data = {
                    lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page: 1,
                    pageSize: 1000,
                }
                this.$api.get_channel_download_type(data).then((res) => {
                    this.downloadtypst = res.data
                    console.log('this.downloadtypstthis.downloadtypst', this.downloadtypst)
                    this.type_id = this.downloadtyps = res.data[0].id
                    this.pcdownloadlist()
                });
            },
            getProductList() {
                let data = {
                    lang: session.get('lang'),
                    channel_id: session.get('channel_id'),
                }
                this.$api.get_channel_category_list(data).then((res) => {
                    // pcdownloadtpmlist
                    console.log('categorylistcategorylistcategorylist', res)
                    this.categorylist = res.data
                    this.maintenancetyps = res.data[0].id || 1
                    this.pcdownloadtpmlist()
                });
            },
            pcdownloadlist() {
                let data = {
                    type_id: this.type_id,
                    mold: 'pc',
                    lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    // page:this.page,
                    page: -1,
                    pageSize: this.pageSize,
                }
                this.$api.get_download_list(data).then((res) => {
                    this.downloadlistst = res.data.data
                    this.total = res.data.total
                });
            },
            pcdownloadtpmlist() {
                let data = {
                    mold: 'pc',
                    lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page: 1,
                    pageSize: this.wehnums,
                    category_id: this.maintenancetyps
                }
                this.$api.get_channel_tpm(data).then((res) => {
                    this.downloadlistst_tpm = res.data
                    this.weihcons = this.downloadlistst_tpm.length
                    if (this.wehnums > this.weihcons && this.wehnums !== this.weihcons) {
                        // if(this.wehnums>=this.weihcons){
                        this.weihtfa = false
                        if (session.get("lang") == "en") {
                            this.quenetworkco = 'up'
                        } else {
                            this.quenetworkco = '收起列表'
                        }
                    } else {
                        this.weihtfa = true
                        if (session.get("lang") == "en") {
                            this.quenetworkco = 'more'
                        } else {
                            this.quenetworkco = '显示更多'
                        }
                    }
                });
            },
            pcproblemtype() {
                let data = {
                    type_id: this.type_id,
                    lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page: 1,
                    pageSize: 10,
                }
                this.$api.get_channel_problem_type(data).then((res) => {
                    this.problemtypest = res.data
                    console.log('pcproblemtype', res.data)
                    if (res.data.length > 0) {
                        this.typesss_id = res.data[0].id
                        this.problemtypestssy = res.data[0].id
                        this.pcproblemlist()
                    }
                });
            },
            pcproblemlist() {
                let data = {
                    type_id: this.typesss_id,
                    mold: 'pc',
                    lang: session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page: 1,
                    pageSize: 10,
                }
                console.log('problemdata:' + data)
                this.$api.get_channel_problem_list(data).then((res) => {
                    this.problemlistst = res.data

                });
            },
            pageParam() {
                let lang = session.get("lang");
                if (lang === "cn") {
                    this.uservices = "用户服务"
                    this.quenetworkco = "显示更多"
                    this.anticoniden = '防伪鉴别',
                        this.haanticoniden = '防伪查询',
                        this.dadownlo = '资料下载',
                        this.maintenance = '维护保养',
                        this.comprob = '常见问题',
                        this.toptitle = '为了方便广大用户查询,我司于近期升级了防伪查询系统'
                    this.foptitle = '温馨提示：您可以在啄木鸟产品外包装的防伪标签上找到防伪码'
                    this.onlinepreview = '在线预览'
                    this.tips = "请输入防伪码"
                    this.querysub = "提交"
                } else {
                    this.uservices = "USERS SERVICE"
                    this.quenetworkco = "Show more"
                    this.anticoniden = 'Anti-Fake Inquiry',
                        this.haanticoniden = 'Anti-Fake Inquiry',
                        this.dadownlo = 'Download',
                        this.maintenance = 'Maintenance',
                        this.comprob = 'FAQ',
                        this.toptitle = 'For accessible checking, our anti-fake inquiry system is newly updated.'
                    this.foptitle = 'Tips: you could find the the security code on the anti-fake laber of Woodpecker product packing.'
                    this.onlinepreview = 'Online preview'
                    this.tips = "Please input anti-fake code"
                    this.querysub = "Submit"
                }
            },
            downloadtypsclick(e) {
                this.downloadtyps = e
                this.type_id = e
                this.page = 1
                this.pcdownloadlist()
            },
            maintenancetypsclick(e) {
                this.maintenancetyps = e
                this.pcdownloadtpmlist()
            },
            problemtypestssyclick(e) {
                this.problemtypestssy = e
                this.typesss_id = e
                this.pcproblemlist()
            },
            aciscoll(e) {
                this.acindex = e
                if (e == 4) {
                    document.getElementById("inscte").scrollIntoView();
                } else if (e == 3) {
                    document.getElementById("paradme").scrollIntoView();
                } else if (e == 2) {
                    document.getElementById("pcmainten").scrollIntoView();
                } else if (e == 1) {
                    document.getElementById("pchoquersf").scrollIntoView();
                }
            },
            handleScroll() {
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()
                if (scrollTop > head_height) {
                    // if(scrollTop>this.scroll_height){
                    this.productc_nav = true
                    // }else{
                    // 	this.productc_nav = false
                    // }
                    // this.scroll_height = scrollTop
                } else {
                    this.productc_nav = false
                }
                let currentScroll = window.pageYOffset
                if (currentScroll < this.$refs.haanticoniden.offsetTop) {
                    this.acindex = 1
                } else if (currentScroll >= this.$refs.haanticoniden.offsetTop && currentScroll < this.$refs.maintenance.offsetTop) {
                    this.acindex = 2
                } else if (currentScroll >= this.$refs.maintenance.offsetTop && currentScroll < this.$refs.dadownlo.offsetTop) {
                    this.acindex = 3
                } else if (currentScroll >= this.$refs.dadownlo.offsetTop && currentScroll < this.$refs.comprob.offsetTop) {
                    this.acindex = 4
                }
                this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
            },
            nextimg() {

                let l = this.list_img.length;
                let scroll = document.getElementById('scroll-x');
                let diatance = scroll.scrollWidth - scroll.clientWidth;
                if (this.current_index == 0) {
                    this.current_index = l - 1;
                    scroll.scrollLeft = diatance;
                } else {
                    this.current_index--;
                    scroll.scrollLeft -= diatance / (l - 1);
                }
            },
            preimg() {
                let l = this.list_img.length;
                let scroll = document.getElementById('scroll-x');
                let diatance = scroll.scrollWidth - scroll.clientWidth;
                if (this.current_index + 1 == l) {
                    this.current_index = 0;
                    scroll.scrollLeft = 0;
                } else {
                    this.current_index++;
                    scroll.scrollLeft += diatance / (l - 1);
                }
            },
            hometo() {
                this.$router.push({path: '/pchome'})
            },
            videoto() {
                this.$router.push({path: '/pcvideos'})

            },
            queryto() {
                this.$router.push({path: '/pcquerys'})
            },
            productto() {
                this.$router.push({path: '/pcproduct'})
            },
            elitesto() {
                this.$router.push({path: '/pcelites'})
            },
            contactusto() {
                this.$router.push({path: '/pccontactus'})
            },
            aboutto() {
                this.$router.push({path: '/pcabout'})
            },
            seachto() {
                this.$router.push({path: '/pcseachs'})
            },
            enter(index) {
                this.navheader = true;
            },
            playenterli() {
                this.playli = false
            },

            playenterri() {
                this.playri = false
            },
            playleaveli() {
                this.playli = true
            },
            playleaveri() {
                this.playri = true
            },
            getParams() {
                let e = this.$route.query.e
                if (e > 0) {
                    this.$nextTick(() => {
                        this.aciscoll(e)
                    })
                }

            }

        },
    }
</script>

<style>


    body {
        margin: 0;
        padding: 0;
        background: #fff;
    }

    .pcdetails {
        width: calc(100vw);
        height: calc(100vh);
        /* overflow-x: hidden; */
        position: relative;
        background: #fff;
    }

    .pchome-headerque {
        width: 100vw;
        position: relative;
        background-size: 100% 100%;
        padding-top: 79px;
        box-sizing: border-box;
    }

    .checse {
        margin-top: 0 !important;
    }

    .product-title {
        color: #fff;
        margin-top: 249px;
        margin-left: 240px;
    }

    .title-hea {
        font-size: 20px;
        font-weight: normal;
        letter-spacing: 1px;
    }

    .title-model {
        margin-top: 15px;
        margin-bottom: 15px;
        font-size: 44px;
        font-weight: normal;
        letter-spacing: 2px;
    }

    .product-but {
        margin-top: 40px;
        font-size: 16px;
        width: 110px;
        height: 46px;
        background: #E31E24;
        border-radius: 23px;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
    }

    /* .header-nav{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .nav-wit {

    }

    .nav-left {
        min-width: 100px;
        height: 50px;
    }

    .nav-left img {
        width: 100px;
        height: 50px;
    }

    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .nav-center-item:first-child {
        margin-left: 0;
    }

    .nav-right {
        min-width: 210px;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }

    .nav-right .search {
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }

    .nav-right .search img {
        width: 100%;
        height: 100%;
    }

    .nav-right .homename {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }

    .nav-right .homename img {
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }

    .nav-right .language {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .nav-right .language img {
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }

    .bb {
        background: #FAFAFA;
        position: fixed;
        top: 0;
        z-index: 99;
    }

    .aboutitem-hea {
        margin-top: 80px;
        margin-bottom: 40px;
        height: 33px;
        font-size: 24px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 33px;
        letter-spacing: 1px;
    }

    .aboutitem-fooitem {
        margin-bottom: 10px;
    }

    .fooitem-left {
        width: 110px;
        height: 32px;
        border-radius: 4px;
        border: 1px solid #EAEAEA;
        display: flex;
        align-items: center;
        justify-content: center;


        font-size: 16px;
        font-weight: 400;
        color: #FAFAFA;
        margin-right: 20px;
    }

    .fooitem-left img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
    }

    .aboutitem-foosus {
        display: flex;
        margin-bottom: 20px;
    }

    .fooitem-right {
        font-size: 16px;
        font-weight: 400;
        color: #CCCCCC;
    }

    .fooitem-cont {
        margin-top: 25px;
        margin-left: 40px;
    }

    .fooitem-cont:first-child {
        margin-left: 0px;
    }

    .fooite-img {
        display: flex;
    }

    .fooite-img img {
        width: 90px;
        height: 90px;
    }

    .fooite-nam {
        text-align: center;
        margin-top: 20px;
    }

    .right-tit {
        margin-bottom: 5px;
    }

    .homefoot {

        height: 94px;
        background: #272727;
        border-top: 2px solid #666;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .foot-hea {
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
    }

    .foot-f {
        height: 22px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .productc {
        width: 1400px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 260px;
        background: rgba(255, 255, 255, .72);
        backdrop-filter: saturate(180%) blur(20px);
    }

    .productc-left {
        font-size: 28px;
        font-weight: 500;
        color: #5d5f5f;
    }

    .productc-right {
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
        display: flex;
    }

    .right-detail {
        margin-right: 24px;
        cursor: pointer;
    }

    .right-parameter {
        margin-right: 24px;
        cursor: pointer;
    }

    .right-instructions {
        margin-right: 24px;
        cursor: pointer;
    }

    .right-maintain {
        cursor: pointer;
    }

    .linesd {
        width: 100%;
        height: 1px;
        background: #EAEAEA;
    }

    .pcho-querysf {
        width: 100%;
        height: 560px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcqueryimg/banner.png) no-repeat;
        background-size: 100% 100%;
    }

    .pcho-queryheasf {
        height: 56px;
        font-size: 40px;
        font-weight: 600;
        color: #fff;
        line-height: 56px;
        letter-spacing: 2px;
    }

    .pcho-querycentsf {
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #fff;
        line-height: 28px;
        letter-spacing: 1px;
        margin-top: 20px;
    }

    .pcho-query-titlesf {
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 40px;
    }

    .pcho-queryinputsf {
        width: 700px;
        height: 60px;
        background: #FFFFFF;
        border-radius: 30px;
        border: 1px solid #CCCCCC;
        display: flex;
        align-items: center;
        margin-top: 40px;
    }

    .pcho-queryinputsf input {
        width: 500px;
        height: 55px;
        border: none;
        border-radius: 30px;
        margin-left: 15px;
        outline: none;
        font-size: 20px;
        color: #5d5f5f;
    }

    .inpt-but {
        margin-left: 65px;
        color: #fff;
        width: 110px;
        height: 46px;
        background: #E31E24;
        border-radius: 23px;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
    }

    input::-webkit-input-placeholder { /* 使用webkit内核的浏览器 */
        width: 127px;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #CCCCCC;
        line-height: 28px;
        letter-spacing: 1px;
    }

    input:-moz-placeholder { /* Firefox版本4-18 */
        width: 127px;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #CCCCCC;
        line-height: 28px;
        letter-spacing: 1px;
    }

    input::-moz-placeholder { /* Firefox版本19+ */
        width: 127px;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #CCCCCC;
        line-height: 28px;
        letter-spacing: 1px;
    }

    input:-ms-input-placeholder { /* IE浏览器 */
        width: 127px;
        height: 28px;
        font-size: 20px;
        font-weight: 400;
        color: #CCCCCC;
        line-height: 28px;
        letter-spacing: 1px;
    }

    .cc {
        color: #D03E3D;
    }

    .parameter {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: -20px;
    }

    .parameter-header {
        display: flex;
        font-size: 18px;
        font-weight: 400;
        color: #666666;
        margin-top: 60px;
        padding-bottom: 60px;
        border-bottom: #EAEAEA 1px solid;
    }

    .instructions {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        background: #FAFAFA;
    }

    .instructions-cont {
        width: 680px;
        height: 320px;
        background: #FAFAFA;
        border-radius: 10px;
        margin-top: 80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .parameter-hea {
        font-size: 40px;
        font-weight: 600;
        color: #5d5f5f;
        letter-spacing: 2px;
        display: flex;
        /* align-items: center;
        justify-content: center; */
        margin-top: 60px;
    }

    .parameter-cen {
        display: flex;
        width: 1400px;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin-left: -24px;
        margin-top: 40px;
        margin-bottom: 60px;
        overflow: hidden;
        position: relative;
        padding-right: 21px;
        /* background: yellow; */
        height: 29px;
    }

    .maintenance-cen {
        display: flex;
        width: 1400px;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin-left: -24px;
        margin-top: 40px;
        margin-bottom: 60px;
        overflow: hidden;
        position: relative;
        padding-right: 21px;
        /* background: yellow; */
        height: 29px;
    }

    .parcen-item {
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
        margin-left: 24px;
        cursor: pointer;
        margin-bottom: 10px;
    }

    .hoverxia_icon {
        width: 21px;
        height: 21px;
        position: absolute;
        top: 0;
        right: -0;
        background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pchomeimg/xiala1.svg);
        background-size: 100% 100%;
    }

    .parameter-foo {
        display: flex;
        /* justify-content: center;
        align-items: center; */
        flex-direction: column;
    }

    .parameter-foo .list-container {
        /*min-height: 500px;*/
    }

    .parfoo-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1400px;
        height: 80px;
        background: #FAFAFA;
        border-radius: 5px;
        margin-bottom: 20px;
    }

    .parfooit-left {
        font-size: 24px;
        font-weight: 500;
        color: #5d5f5f;
        letter-spacing: 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 20px;
    }

    .parfooit-left img {
        width: 40px;
        height: 40px;
        margin-right: 20px;
    }

    .parfooit-right {
        font-size: 24px;
        font-weight: 400;
        color: #D03E3D;
        letter-spacing: 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 26px;
        cursor: pointer;

    }

    .parfooit-right img {
        width: 40px;
        height: 40px;
        margin-left: 20px;
    }

    .instructions-hea {
        font-size: 40px;
        font-weight: 600;
        color: #5d5f5f;
        letter-spacing: 2px;
        margin-top: 80px;
    }

    .instructions-cen {
        width: 1400px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
        margin-left: -24px;
        margin-top: 40px;
        margin-bottom: 60px;
        padding-right: 21px;
        position: relative;
        overflow: hidden;
        flex-wrap: wrap;
        height: 29px;
    }

    .instructions-foo {
        padding-bottom: 50px;
    }

    .inscen-item {
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
        margin-left: 24px;
        cursor: pointer;
        margin-bottom: 10px;
    }

    /* .inscen-item:first-child{
        margin-left: 0;
    } */
    .el-collapse-item {
        width: 1400px;
        border: none;
        margin-bottom: 20px;
        background-color: #fff;
    }

    .el-collapse-item__header {
        border: none;
    }

    .el-collapse-item__header {
        font-size: 24px;
        font-weight: 600;
        color: #5d5f5f;
        letter-spacing: 1px;
        margin-left: 40px;
    }

    .el-collapse {
        border: none;
    }

    .el-collapse-item__wrap {
        border: none;
    }

    .el-collapse-item__content {
        margin-left: 40px;
        font-size: 18px;
        font-weight: 500;
        color: #666666;
    }

    .downloadtypsclass {
        color: #D03E3D;
    }

    .problemtypestssyclass {
        color: #D03E3D;
    }

    .pcmaintenance {

        width: 1400px;
        padding: 80px 240px;
    }

    .pcmanitenance-hea {
        font-size: 40px;
        font-weight: 600;
        color: #5d5f5f;
        letter-spacing: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .pcmaintenance-cont {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
    }

    .pcmaintenance-item {
        width: 320px;
        margin-right: 40px;
        margin-bottom: 40px;
        cursor: pointer;
        /* position: relative;
        height: 180px;
        display: flex;
        cursor: pointer; */
        /* display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: #000000; */
        /* background-color: #000000; */
    }

    .pcmaintenance-item:nth-child(4n) {
        margin-right: 0px;
    }

    .maintenanceitem-hea {
        width: 320px;
        height: 180px;
        overflow: hidden;
        border-radius: 6px;
    }

    .maintenanceitem-hea:hover img {
        cursor: pointer;
        width: 320px;
        height: 180px;
        /* transform: scale(1.1,1.1); */
    }

    .maintenanceitem-hea img {
        width: 320px;
        height: 180px;
        border-radius: 6px;
        transition: all 1s linear;
    }

    .maintenanceitem-foo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
    }

    .maintenanceitem-left {
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
    }

    .maintenanceitem-right {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 16px;
    }

    .maintenanceitem-right img {
        width: 20px;
        height: 20px;
        margin-left: 10px;
    }

    .querymainmore {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .quemore-but {
        padding: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #999;
        border-radius: 5px;
        font-size: 16px;
    }

    .quemore-but img {
        margin-left: 5px;
        width: 16px;
        height: 16px;
    }

    /* .header-nav{
        width: 1400px;
        height: 79px;
        display: flex;
        align-items: center;
        padding: 0 260px;
        position: fixed;
        top: 0;
    } */
    .nav-wit {

    }

    .nav-left {
        width: 100px;
        height: 50px;
    }

    .nav-left img {
        width: 100%;
        height: 100%;
    }

    /* .nav-center-item:hover{
        border-bottom: 2px solid #E31E24;
    } */

    .nav-center-item:first-child {
        margin-left: 0;
    }

    .nav-right {
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        margin-left: 180px;
    }

    .nav-right .search {
        display: flex;
        align-items: center;
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
    }

    .nav-right .search img {
        width: 100%;
        height: 100%;
    }

    .nav-right .homename {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        cursor: pointer;
    }

    .nav-right .homename img {
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }

    .nav-right .language {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .nav-right .language img {
        width: 16px;
        height: 16px;
        margin-left: 6px;
    }

    .bbasdfa {
        background-color: #fff;
        position: fixed;
        top: 79px;
    }

    .productc_nav {
        position: fixed;
        z-index: 1;
        top: 0%;
        background-color: #fff;
        background: rgba(255, 255, 255, .72);
        backdrop-filter: saturate(180%) blur(20px);
    }

    .pcmaintenance-item video {
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }

    .video_title_image {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }

    .shopicon-left {
        font-size: 16px;
        font-weight: 400;
        color: #5d5f5f;
    }

    .shopicon-right {
        width: 20px;
        height: 20px;
        margin-right: 12px;
        cursor: pointer;
        display: flex;
    }

    .shopicon-right img {
        width: 100%;
        height: 100%;
    }

    .shop-icon {
        width: 320px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
    }

    .shop-video {
        position: relative;
        width: 320px;
        height: 180px;
        display: flex;
    }

    .pagination {
        text-align: center;
    }

    .pagination .el-pagination {
        height: 100px;
    }

    .pagination.wood .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #e62129;
    }

    .pagination .el-pagination.is-background .el-pager li:not(.active):hover {
        color: #e62129;
    }

    .pagination.dte .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #1a4698;
    }

    .pagination.dte .el-pagination.is-background .el-pager li:not(.active):hover {
        color: #1a4698;
    }

    .pagination.dba .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #5f5d5d;
    }

    .pagination.dba .el-pagination.is-background .el-pager li:not(.active):hover {
        color: #5f5d5d;
    }
</style>
